import { store } from '../store/store';
import { HttpRequest } from '../utils';

const httpRequest = new HttpRequest(store);

export const list = async (data: { page: number; limit: number; query?: string }) => {
  const res = await httpRequest.get('/api/option', data);
  return res;
};

export const create = async (data: { name: string; nameEng: string }) => {
  const res = await httpRequest.post('/api/option', data);
  return res;
};

export const get = async (id: string) => {
  const res = await httpRequest.get(`/api/option/${id}/detail`);
  return res;
};

export const select =
  (modelId: string) =>
  async ({ query }: { modelId: string; query: string }) => {
    const res = await httpRequest.get(`/api/option/select`, {
      carModelId: modelId,
      query,
      limit: 10000,
    });
    return res;
  };

export const remove = async (id: string) => {
  const res = await httpRequest.del(`/api/option/${id}`);
  return res;
};

export const update = async ({
  id,
  name,
  extraPercent,
  level,
  carModelId,
  values,
}: {
  id: string;
  name: string;
  extraPercent: number;
  level: string;
  carModelId: string;
  values: { name: string }[];
}) => {
  const res = await httpRequest.put(`/api/option/${id}/update`, {
    name,
    extraPercent,
    level,
    carModelId,
    values,
  });
  return res;
};
